import { device, store as libraryStore } from '@rfc/rfc-components-library/store'
import { Store, createStore } from 'vuex'
import hubDevice from './deviceStore/device.module'
import { type UrtimeStoreState } from './storeType'

//import modules used
import type { Router } from 'vue-router'
import i18n from '../locales/i18n'
import checkpoint from './checkpointStore/checkpoint.module'
import event from './eventStore/event.module'
import filters from './filtersStore/filters.module'
import notification from './notificationStore/notification.module'
import partner from './partnersStore/partners.module'

const setupStore = (storeRouter: Router): Store<UrtimeStoreState> =>
    createStore({
        modules: {
            ...libraryStore(storeRouter as any, i18n as any),
            device: {
                ...device,
                actions: { ...device.actions(storeRouter, i18n as any), ...hubDevice.actions }
            },
            checkpoint,
            event: {
                ...event,
                actions: event.actions(storeRouter)
            },
            filters,
            notification,
            partner: {
                ...partner,
                actions: partner.actions(storeRouter)
            }
        },
        devtools: true
    })

export default setupStore
